"use client"

import clsx from "clsx"
import { NpFeaturedProductItem } from "src/components/home/NpFeaturedProductItem"
import { NpHomePageProductData } from "src/components/home/types"
import {
  npPageGapClassName,
  npPagePtClassName,
  npPageWidthClassName,
} from "src/components/np-design/components/constants"

export type NpFeaturedProductsProducts = {
  listId: string
  products: NpHomePageProductData[]
}

export const NpFeaturedProducts = ({ listId, products }: NpFeaturedProductsProducts) => {
  return (
    <div
      className={clsx(
        npPageWidthClassName,
        npPagePtClassName,
        npPageGapClassName,
        "mx-auto max-w-full",
        "flex flex-col items-center justify-center md:flex-row md:flex-wrap md:items-stretch",
      )}
    >
      {products.map((data, index) => {
        return <NpFeaturedProductItem key={index} listId={listId} data={data} />
      })}
    </div>
  )
}
